const sensorsdata  = function(production) {
  let para =  {
    sdk_url: 'https://static.roadshowchina.cn/public/statics/plugin/jsdelivrshence/sensorsdata.min.js?v=1',
    heatmap_url: 'https://static.roadshowchina.cn/public/statics/plugin/jsdelivrshence/heatmap.min.js?v=1',
    name: 'sensors',
    server_url:  window.location.host.indexOf('vote.roadshowchina.cn') >-1? 'https://sensors-datasink.roadshowchina.cn/sa?project=production' : 'https://sensors-datasink.roadshowchina.cn/sa?project=default' ,
    heatmap: {
      scroll_notice_map: 'default'
    },
    app_js_bridge:true,
    show_log:false
  }
  var p = para.sdk_url, n = para.name, w = window, d = document, s = 'script',x = null,y = null;
  if(typeof(w['sensorsDataAnalytic201505']) !== 'undefined') {
      return false;
  }
  w['sensorsDataAnalytic201505'] = n;
  w[n] = w[n] || function(a) {return function() {(w[n]._q = w[n]._q || []).push([a, arguments]);}};
  var ifs = ['track','quick','register','registerPage','registerOnce','trackSignup', 'trackAbtest', 'setProfile','setOnceProfile','appendProfile', 'incrementProfile', 'deleteProfile', 'unsetProfile', 'identify','login','logout','trackLink','clearAllRegister','getAppStatus'];
  for (var i = 0; i < ifs.length; i++) {
    w[n][ifs[i]] = w[n].call(null, ifs[i]);
  }
  if (!w[n]._t) {
    x = d.createElement(s), y = d.getElementsByTagName(s)[0];
    x.async = 1;
    x.src = p;
    x.setAttribute('charset','UTF-8');
    w[n].para = para;
    y.parentNode.insertBefore(x, y);
  }
  // 注册公共属性
sensors.registerPage({
  platform_type: 'IR峰会第八届'
});

sensors.quick('autoTrack');

}

export default sensorsdata






// WEBPACK FOOTER //
// ./src/utils/autotrack.js